export const SET_SECONDARY_NAV_DATA = "SET_SECONDARY_NAV_DATA"
export const GET_SECONDARY_NAV_DATA = "GET_SECONDARY_NAV_DATA"
export const SET_IS_IN_SECONDARY_NAV = "SET_IS_IN_SECONDARY_NAV"
export const SET_DEFAULT_SECONDARY_CONFIG = "SET_DEFAULT_SECONDARY_CONFIG"
export const SET_IS_IMAGE_PLACEHOLDER_ENABLED = "SET_IS_IMAGE_PLACEHOLDER_ENABLED"
export const SET_IS_IN_TERTIARY_NAV = "SET_IS_IN_TERTIARY_NAV"
export const SET_TERTIARY_NAV_INDEX = "SET_TERTIARY_NAV_INDEX"
